/* aw-sorteer.js — het sorteerpaneel op de collectiepagina.
 *
 * Zelfde mechaniek als het maattabelvenster (aw-maattabel.js), en dat is met
 * opzet: het is dezelfde beweging uit dezelfde bron.
 *   vanaf 700px  het hele paneel van 0 naar 1 in 0,2s
 *   daaronder    de waas van 0 naar 1 en het blad van translateY(100%) naar 0,
 *                allebei 0,3s met cubic-bezier(.645,.045,.355,1), tegelijk
 */
(() => {
  if (window.__awSorteer) return;
  window.__awSorteer = true;

  const BREED = window.matchMedia('(min-width: 700px)');
  let vorigeKnop = null;
  const paneel = () => document.getElementById('aw-sorteer');

  /* Alleen op de telefoon zetten we de pagina op slot: daar is het een blad
     over het scherm. Op het bureaublad is het een paneeltje bij de knop en mag
     de pagina gewoon blijven schuiven. */
  function slot(aan) {
    if (BREED.matches) return;
    [document.documentElement, document.querySelector('.page-wrapper')]
      .forEach((el) => { if (el) el.style.overflow = aan ? 'hidden' : ''; });
  }

  function open(knop) {
    const p = paneel();
    if (!p || p.hasAttribute('open')) return;
    vorigeKnop = knop || null;
    p.hidden = false;
    void p.offsetWidth;            // begintoestand afdwingen
    p.setAttribute('open', '');
    slot(true);
    if (knop) knop.setAttribute('aria-expanded', 'true');
    const vak = p.querySelector('.aw-sorteer__vak');
    if (vak) vak.focus({ preventScroll: true });
  }

  function dicht() {
    const p = paneel();
    if (!p || !p.hasAttribute('open')) return;
    p.removeAttribute('open');
    slot(false);
    document.querySelectorAll('[data-aw-sorteer-open]')
      .forEach((k) => k.setAttribute('aria-expanded', 'false'));

    const beweger = BREED.matches ? p : p.querySelector('.aw-sorteer__vak');
    let gedaan = false;
    const klaar = () => { if (gedaan) return; gedaan = true; if (!p.hasAttribute('open')) p.hidden = true; };
    if (beweger) beweger.addEventListener('transitionend', klaar, { once: true });
    setTimeout(klaar, 420);

    if (vorigeKnop && document.contains(vorigeKnop)) vorigeKnop.focus({ preventScroll: true });
    vorigeKnop = null;
  }

  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-aw-sorteer-open]');
    if (knop) { e.preventDefault(); open(knop); return; }
    if (e.target.closest('[data-aw-sorteer-sluit]')) { e.preventDefault(); dicht(); return; }
    /* Op het bureaublad is er geen waas; buiten het paneel klikken sluit hem. */
    const p = paneel();
    if (p && p.hasAttribute('open') && BREED.matches && !e.target.closest('.aw-sorteer__vak')) dicht();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') dicht();
  });
})();
